import React from 'react';
import { Zoom, Fade } from 'react-reveal';
import { images } from '../../settings';

import './Comunicacao.scss';

class Comunicacao extends React.Component {
  render() {
    return (
      <div className="comunicacao">
        <div className="comunicacao__conteudo">
          <div className="comunicacao__texto-imagem">
            <div className="comunicacao__texto">
              <h3 className="comunicacao__titulo green">
                <span className="gri_text">
                  Comunicação
                  <span className="gri_label">
                    GRI <b>102-43</b>
                  </span>
                </span>
              </h3>
              <p>
                Para estarmos sempre próximos dos associados, utilizamos diferentes ferramentas de comunicação. Queremos
                ouvir o que eles têm a dizer e dar transparência às informações da Associação. Em 2019, consolidamos o
                uso do WhatsApp e do Workplace como importantes canais de comunicação.
              </p>
              <p>
                Foram <strong className="green">83 mensagens</strong> enviadas pelo{' '}
                <strong className="green">WhatsApp</strong>: notícias em primeira mão sobre as nossas atividades,
                respostas a audiências públicas, novidades dos reguladores, além de comunicados sobre publicações e
                eventos que lançamos. A ferramenta é democrática – basta trabalhar em uma instituição associada e entrar
                em contato pelo{' '}
                <a href="mailto:centraldoassociado@anbima.com.br" className="text_link text_link--green">
                  centraldoassociado@anbima.com.br
                </a>{' '}
                para se cadastrar e então receber as mensagens.
              </p>
            </div>
            <div className="comunicacao__imagem-whats comunicacao__imagem-whats--desktop">
              <img src={images.associados.WhatsMensagens} alt="Mensagens trocadas" />
              <img className="whats-pessoa" src={images.associados.WhatsMensagensPessoa} alt="Mensagens trocadas" />
            </div>
          </div>
          <div className="comunicacao__texto comunicacao__texto--baixo">
            <p>
              No <strong className="green">Workplace</strong>, lançado em julho, temos um grupo geral para todos os
              associados, no qual foram feitas <strong className="green">58 publicações</strong>. Cada fórum de
              representação tem um espaço exclusivo, onde são divulgadas atas das reuniões presenciais, informações mais
              aprofundadas sobre as consultas públicas que participamos, entre outras pautas. Veja como foi a
              movimentação por lá neste ano:
            </p>
          </div>
          <div className="comunicacao__imagem-whats comunicacao__imagem-whats--mobile">
            <img src={images.associados.WhatsMensagens} alt="Mensagens trocadas" />
            <img className="whats-pessoa" src={images.associados.WhatsMensagensPessoa} alt="Mensagens trocadas" />
          </div>
        </div>
        <div className="associados-grupos-posts">
          <div className="associados-grupos-posts__container">
            <div className="associados-posts-container">
              <div className="associados-posts-titulo">
                <div className="associados-posts-titulo__container-titulo">
                  <img src={images.associados.iconeLapis} alt="Ícone lápis" />
                  <h3 className="associados-posts-titulo__titulo">Publicação</h3>
                </div>
                <div className="associados-posts-titulo__risca"></div>
                <div className="associados-posts-titulo__qtd-posts">
                  <h3 className="associados-posts-titulo__titulo-qtd">
                    <span className="associados-posts-titulo__numero">
                      <Zoom>58</Zoom>
                    </span>{' '}
                    <span className="associados-posts-titulo__texto">
                      <Zoom>posts</Zoom>
                    </span>
                  </h3>
                  <h4 className="associados-posts-titulo__subtitulo-qtd">publicados no espaço do associado</h4>
                  <div className="associados-posts-titulo__like">
                    <img src={images.associados.likeIcon} alt="Ícone Curtir" />
                    <img className="icone-curtir icone-1" src={images.associados.likeIcon} alt="Ícone Curtir" />
                    <img className="icone-curtir icone-2" src={images.associados.likeIcon} alt="Ícone Curtir" />
                    <img className="icone-curtir icone-3" src={images.associados.likeIcon} alt="Ícone Curtir" />
                  </div>
                </div>
              </div>
            </div>
            <div className="associados-grupo">
              <div className="associados-grupo__header">
                <img src={images.associados.iconeGrupos} alt="Ícone Grupos" />
                <h3 className="associados-grupo__titulo">Por grupos</h3>
              </div>
              <Fade right cascade>
                <div className="associados-grupo-itens">
                  <div className="associados-grupo-itens__linha">
                    <div className="associados-grupo-itens__numero associados-grupo-itens__numero--azul-escuro">
                      <span>26</span>
                    </div>
                    <div className="associados-grupo-itens__texto">
                      <span>Distribuição</span>
                    </div>
                  </div>
                  <div className="associados-grupo-itens__linha">
                    <div className="associados-grupo-itens__numero associados-grupo-itens__numero--azul-claro">
                      <span>31</span>
                    </div>
                    <div className="associados-grupo-itens__texto">
                      <span>Estruturação de Mercado de Capitais</span>
                    </div>
                  </div>
                  <div className="associados-grupo-itens__linha">
                    <div className="associados-grupo-itens__numero associados-grupo-itens__numero--verde-agua">
                      <span>18</span>
                    </div>
                    <div className="associados-grupo-itens__texto">
                      <span>Gestão de Fundos Estruturados</span>
                    </div>
                  </div>
                  <div className="associados-grupo-itens__linha">
                    <div className="associados-grupo-itens__numero associados-grupo-itens__numero--laranja">
                      <span>28</span>
                    </div>
                    <div className="associados-grupo-itens__texto">
                      <span>Gestão de Fundos Mútuos</span>
                    </div>
                  </div>
                  <div className="associados-grupo-itens__linha">
                    <div className="associados-grupo-itens__numero associados-grupo-itens__numero--amarelo">
                      <span>16</span>
                    </div>
                    <div className="associados-grupo-itens__texto">
                      <span>Negociação</span>
                    </div>
                  </div>
                  <div className="associados-grupo-itens__linha">
                    <div className="associados-grupo-itens__numero associados-grupo-itens__numero--verde">
                      <span>18</span>
                    </div>
                    <div className="associados-grupo-itens__texto">
                      <span>Serviços Fiduciários</span>
                    </div>
                  </div>
                </div>
              </Fade>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export { Comunicacao };
